import ApiRequest, { type AxiosError, type AxiosResponse, type ICustomResponse } from '@frontend/request';

import { configViewController } from '@aqx-core/common/services/config';
import storage, { EStorageKey } from '@aqx-core/common/storage';

import { maintenanceViewController } from '../services/maintenance';
import { checkForDownload } from '../utils/export';
import { EHttpResponseCode } from './types';

export * from './types';
export * from './message';

const request = new ApiRequest({
  onRequest: (axiosConfigs) => {
    const url = axiosConfigs.url || '';
    const token = storage.getItem(EStorageKey.TOKEN) as string;

    const axiosBaseConfigs = {
      ...axiosConfigs,
      baseURL: configViewController.getCurrentApiDomain()
    };

    if (token) {
      if (['/api/support/v1/ticket'].includes(url)) {
        axiosBaseConfigs.headers['Authorization'] = `Bearer ${token}`;
        axiosBaseConfigs.headers['Accept'] = 'application/json';
        axiosBaseConfigs.headers['Content-Type'] = 'multipart/form-data';
      } else if (!['/api/auth/v1/company/login'].includes(url)) {
        axiosBaseConfigs.headers['Authorization'] = `Bearer ${token}`;
      }
    }

    return axiosBaseConfigs;
  },
  onResponse: (response: AxiosResponse) => {
    maintenanceViewController.checkForMaintenance(response);
    // Automatically check for file downloads in all responses
    checkForDownload(response);
  },
  onError: (error: AxiosError<ICustomResponse<never>>) => {
    if (error.response?.status === EHttpResponseCode.METHOD_NOT_ALLOWED) {
      maintenanceViewController.activateMaintenanceMode();
      return null;
    }

    /**
     * Removed the fallback domain network error handler; the application now relies solely on geolocation-based IP detection
     * to determine the correct domain (via configViewController.switchToFallbackDomain in geolocation controller).
     */

    return null;
  }
});

export { request };
